import conference from "./conference.vue";
export default conference;
